import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';

import { FormFieldBaseComponent } from 'src/app/shared/components/form-field-base/form-field-base.component';
import { required } from 'src/app/shared/decorators/required.decorator';

import { DefaultMatcher } from '@shared/helpers/default-error-state-matcher';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.scss'],
})
export class SelectFieldComponent<T>
  extends FormFieldBaseComponent<T>
  implements OnChanges
{
  @Input() @required optionTitlePrefix!: string;
  @Input() @required enum!: any;

  @Input() hasEmptyOption: boolean = true;
  @Input() isMultiple: boolean = false;
  @Input() showSelectedLabels: boolean = false;
  @Input() hideRequiredMarker: boolean = false;
  @Input() limit: number = 0;
  @Input() errorStateMatcher: ErrorStateMatcher = new DefaultMatcher();
  @ViewChild('selectField') selectField!: any;

  limitReached = false;
  selectedValues: any[] = [];

  override ngOnChanges(): void {
    super.ngOnChanges();
    this.selectedValues = this.control.value;
    if (!this.control.value) {
      this.selectedValues = [];
    }
  }

  override onValueChange(ev: any): void {
    this.selectedValues = ev;
    if (this.limit > 0) {
      if (ev.length >= this.limit) {
        this.limitReached = true;
      } else {
        this.limitReached = false;
      }
    }
    this.valueChange.emit(ev);
  }

  removeSelected(key: string) {
    this.selectedValues = this.selectedValues.filter((value) => value !== key);
    this.control.setValue(this.selectedValues);
    this.onValueChange(this.selectedValues);
  }

  onSelectField(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.selectField.close();
    }
  }
}
